const {
  findEligibleAchievementFromBetslip,
  findEligibleAchievementFromBasket,
  isBetslipStillEligible,
  isBetEligible,
} = require('./services/eligibility');

module.exports = {
  findEligibleAchievementFromBetslip,
  findEligibleAchievementFromBasket,
  isBetslipStillEligible,
  isBetEligible,
};
